import HttpService from '@src/utility/httpService';
import { checkIsInternal } from '@src/utility/createStorage';
import { config } from '@uhg-abyss/web/tools/config';
import { callsAndChatsSummary } from './apiUrlConstants';

const _httpService = new HttpService();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL') as string);
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL') as string);
}

/**
 * Fetch PSMS Calls/Chats Details Summary
 * Endpoint: calls/psmsDetails?psmsCallChatRequestType=SUMMARY
 * @param payload - Optional payload. If not provided, uses static default payload
 */
export const getPSMSCallsChatsDetails = async (payload?: any) => {
  const url = `${callsAndChatsSummary}?psmsCallChatRequestType=SUMMARY`;

  const requestPayload = payload || {};

  try {
    const response: any = await _httpService.push(url, requestPayload);
    return response;
  } catch (error) {
    console.error('getPSMSCallsChatsDetails error:', error);
    throw error;
  }
};

/**
 * Fetch PSMS Calls/Chats Trend Data
 * Endpoint: calls/psmsDetails?psmsCallChatRequestType=TREND
 */
export const getPSMSCallsChatsTrend = async (payload?: any) => {
  const url = `${callsAndChatsSummary}?psmsCallChatRequestType=TREND`;

  const requestPayload = payload || {};

  try {
    const response: any = await _httpService.push(url, requestPayload);
    return response;
  } catch (error) {
    console.error('getPSMSCallsChatsTrend error:', error);
    throw error;
  }
};
